export function setCookie(cookie_name, token, expires_at) {
    if (typeof document !== "undefined") {
        token = encodeURIComponent(token);
        const today = new Date();
        const diffSeconds = new Date(expires_at) - today;
        var expires = "expires=" + diffSeconds;
        
        document.cookie = cookie_name + "=" + token + ";" + expires + ";path=/";
    }
}

export function removeCookie(cookie_name) {
    setCookie(cookie_name, "", "Thu, 01 Jan 1970 00:00:00 GMT");
}

export function getCookie(cookie_name) {
    if (typeof document !== "undefined") {
        var name = cookie_name + "=";
        var decodedCookie = decodeURIComponent(document.cookie);
        var ca = decodedCookie.split(";");
        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == " ") {
                c = c.substring(1);
            }
            if (c.indexOf(name) == 0) {
                return decodeURIComponent(c.substring(name.length, c.length));
            }
        }
    }
    return "";
}
export const Cookie = {
  get: getCookie,
  set: setCookie,
  remove: removeCookie,
};

